<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import InboxActionSelectCell from "./_modules/inbox-action-select-cell"

  let props: InboxWorkflowCellProps = $props()

  const value = $derived(
    typeof props.binding.value === "string" || typeof props.binding.value === "number"
      ? String(props.binding.value)
      : "",
  )
</script>

<InboxActionSelectCell
  {value}
  options={props.binding.options.map((option) => ({
    value: option.value,
    label: option.label ?? option.name ?? option.value,
    disabled: option.disabled,
    tooltipContent: option.tooltipContent,
    description: option.description,
    dataTestid: option.dataTestid,
  }))}
  disabled={props.binding.disabled}
  ariaLabel={props.columnConfig.placeholder ?? props.column.label}
  placeholder={props.columnConfig.placeholder ?? props.column.label}
  onChange={(next) => props.binding.setValue(next)}
/>
